module.exports = require("react-dom");


//////////////////
// WEBPACK FOOTER
// external "react-dom"
// module id = 541
// module chunks = 0